import HttpService from "./http.service";

// Route to create a new dispatch
export const createDispatch = async(data) => {
    return await HttpService.post("/dispatches", data);
};

// Route to get all the dispatches
export const getDispatches = async() => {
    return await HttpService.get("/dispatches");
};

// Route to get a dispatch by its ID
export const getDispatchById = async(dispatchId) => {
    return await HttpService.get(`/dispatches/${dispatchId}`);
};

// Route to get dispatches for a specific organization
export const getOrgDispatches = async(orgId) => {
    return await HttpService.get(`/dispatches/org/${orgId}`);
};

// Route to update an existing dispatch
export const updateDispatch = async(dispatchId, data) => {
    return await HttpService.patch(`/dispatches/${dispatchId}`, data);
};
// Update dispatch status
export const updateDispatchStatus = async (dispatchId, data) => {
    return await HttpService.patch(`/dispatches/status/${dispatchId}`, data);
};

// Get recent dispatches, optionally filtered by organization
export const getRecentDispatches = async (orgId)=>{
    return await HttpService.get(`/dispatches/recent/${orgId}`);
};

// Delete a dispatch by its ID
export const deleteDispatch = async (dispatchId, userId) => {
    return await HttpService.delete(`/dispatches/${dispatchId}/${userId}`);
};

// Route exports
export default {
    createDispatch,
    getDispatches,
    getDispatchById,
    getOrgDispatches,
    updateDispatch,
    updateDispatchStatus,
    getRecentDispatches,
    deleteDispatch
};